// Oppdager om appen kjører i en innebygd nettleser (in-app webview)
// som Snapchat, Instagram, Facebook, TikTok osv.
//
// Google-innlogging (OAuth) blokkeres av Google i slike webviews med
// feilen "403: disallowed_useragent". Vi oppdager det og ber brukeren
// åpne i ekte nettleser i stedet.

// Returnerer navnet på appen hvis vi er i en kjent in-app-nettleser,
// ellers null.
export function getInAppBrowser() {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || navigator.vendor || '';

  // Kjente in-app-nettlesere og signaturene i user-agent
  const matchers = [
    { name: 'Snapchat', test: /Snapchat/i },
    { name: 'Instagram', test: /Instagram/i },
    { name: 'Facebook', test: /FBAN|FBAV|FB_IAB/i },
    { name: 'Messenger', test: /Messenger/i },
    { name: 'TikTok', test: /musical_ly|ByteLocale|ByteFullLocale|Bytedance|TikTok/i },
    { name: 'Twitter', test: /Twitter/i },
    { name: 'LinkedIn', test: /LinkedInApp/i },
    { name: 'Line', test: /\bLine\//i },
    { name: 'Pinterest', test: /Pinterest/i },
    { name: 'Snapchat', test: /SnapCamera/i },
  ];

  for (const m of matchers) {
    if (m.test.test(ua)) return m.name;
  }

  return null;
}

// True hvis vi er i en in-app-nettleser der Google-innlogging trolig blokkeres.
export function isInAppBrowser() {
  return getInAppBrowser() !== null;
}

// Grov plattform-deteksjon for å gi riktig "åpne i nettleser"-instruksjon.
export function getPlatform() {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}
